export { default, default as SkipLink } from './SkipLink'
export { default as skipLinkTheme } from './themes/SkipLink.theme'
export * as SkipLinkStyles from './styles/SkipLink.style'

export type { SkipLinkProps } from './SkipLink.types'
export type { AppearanceKeys, SkipLinkTheme } from './themes/SkipLink.theme.types'
export type { StyledSkipLinkProps } from './styles/SkipLink.style.types'
